import styled from 'styled-components';
import { Body, Card, TrevorIcon } from '@trevor/ui-components';

export const HowDoICardContainer = styled(Card).attrs({
  width: '100%',
  padding: 24,
  gap: 24,
})`
  width: inherit;
  margin: 25px 19px;
  border: 1px solid var(--color-interface-layout-normal);
  box-shadow: unset;
`;

export const ShowMore = styled(Body).attrs({ variant: 2 })`
  color: var(--color-interface-secondary-normal);
  text-decoration: underline;
  margin-top: var(--spacing-s);
  cursor: pointer;
  text-align: center;
`;

export const RelatedArticleContainer = styled.li`
  color: var(--color-interface-secondary-normal);

  > a {
    display: flex;

    > p {
      color: inherit;
      text-decoration: underline;
      margin-right: calc(var(--spacing-xxs) * 2);
    }
  }
`;

export const RelatedArticleList = styled.ul`
  margin: unset;
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s);
`;

export const ColumnGap12Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-m);
`;

export const ColumnGap4Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacing-xxs) * 2);
`;

export const LoadingIcon = styled(TrevorIcon).attrs({ name: 'spinner' })`
  width: 24px;
  height: 24px;
  margin: auto;
  animation: loading 3s linear infinite;
  opacity: 1 !important;
  @keyframes loading {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
